module.exports = __webpack_public_path__ + "img/jm5.3a3536c9.png";